import { Fragment } from 'react/jsx-runtime'

import StarIcon from '@/modules/chatting/icons/star.svg'
import type { ListUser } from '@/modules/chatting/types'
import { classNames } from '@/utils/helpers'

interface Props {
  user: ListUser
}

export const ScrollingUserLists = ({ user }: Props) => {
  return (
    <div className="flex items-center gap-1 py-[1px] text-[11px]">
      <StarIcon
        className={classNames('h-4 w-4 shrink-0 text-primary-500', {
          'fill-primary-500': !!user.listsStates?.length,
        })}
      />
      <div className="no-scrollbar flex max-w-full gap-1 overflow-auto whitespace-nowrap text-xs font-medium leading-[18px]">
        {user.listsStates?.length ? (
          <>
            <span className="">Lists</span>
            {user.listsStates?.map(({ id, name }) => (
              <Fragment key={id}>
                <div className="text-[8px]">&#x2022;</div>
                <span>{name}</span>
              </Fragment>
            ))}
          </>
        ) : (
          'Add to favorites and other lists'
        )}
      </div>
    </div>
  )
}
